module.exports = __webpack_public_path__ + "img/marketwatch-img.2351e8b6.png";